module.exports = __webpack_public_path__ + "static/media/cows.87d417ac.jpg";